import { useEffect } from 'react';
import { useSignal } from '@funtech-int/rival-react';

import { CHANNEL_COUNT_FOR_WALLPAPER } from '../constants';
import { ChannelWallpaperManager } from '../lib/channelWallpaperManager';
import { getChannelCategoryIdsByTabId } from '../lib/utils/getChannelCategoryIdsByTabId';
import { getChannelsWallpapers } from '../lib/utils/getChannelsWallpapers';

import { useChannelCategoryTabQueryParam } from './useChannelCategoryTabQueryParam';
import { useChannelListQuery } from './useChannelListQuery';

interface UseChannelWallpapersProps {
    wallpapperChannelsManager: ChannelWallpaperManager;
}

export const useChannelWallpapers = ({ wallpapperChannelsManager }: UseChannelWallpapersProps) => {
    const channelCategoryTabId = useChannelCategoryTabQueryParam();
    const categoryIds = getChannelCategoryIdsByTabId(channelCategoryTabId);
    const { channelList } = useChannelListQuery({
        categoryIds,
    });
    const baseChannelsWallpapers = getChannelsWallpapers(channelList?.channels ?? []);

    const hasEnoughCurrentCategoryChannelsForPaywall =
        baseChannelsWallpapers.length >= CHANNEL_COUNT_FOR_WALLPAPER;

    const channelsWallpapers = useSignal(wallpapperChannelsManager.channelsWallpapers);
    const channelPaywallListLoading = useSignal(wallpapperChannelsManager.loading);

    useEffect(() => {
        if (!hasEnoughCurrentCategoryChannelsForPaywall && !channelPaywallListLoading) {
            wallpapperChannelsManager.loadChannels();
        }
    }, [
        categoryIds,
        hasEnoughCurrentCategoryChannelsForPaywall,
        wallpapperChannelsManager,
        channelPaywallListLoading,
    ]);

    if (channelPaywallListLoading) {
        return undefined;
    }

    return [...baseChannelsWallpapers, ...channelsWallpapers];
};
